"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Base_1 = require("./Base");
const typography_1 = require("../../shared/typography");
const resolveModalVariant = (variant) => {
    switch (variant) {
        case "small":
            return "387px";
        case "regular":
            return "45%";
        default:
            return "387px";
    }
};
const Modal = ({ children, title, bottomSection, onOverlayClick, variant = "small" }) => {
    return ((0, jsx_runtime_1.jsx)(Base_1.ModalBase, { onCloseModal: onOverlayClick, children: (0, jsx_runtime_1.jsx)(Body, { "data-variant": variant, children: (0, jsx_runtime_1.jsxs)(Wrapper, { variant: resolveModalVariant(variant), "data-variant": variant, children: [(0, jsx_runtime_1.jsx)("div", { children: typeof title === "string" ? (0, jsx_runtime_1.jsx)(typography_1.H2, { children: title }, void 0) : title }, void 0), (0, jsx_runtime_1.jsx)("div", { children: children }, void 0), bottomSection && (0, jsx_runtime_1.jsx)("div", { children: bottomSection }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.Modal = Modal;
const Body = styled_components_1.default.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    &[data-variant="small"] {
      align-items: flex-end;
    }
  }
`;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: ${({ variant }) => variant};
  max-height: 100vh;

  h2 {
    margin-bottom: 0;
  }

  p {
    line-height: 1.5;
  }

  & > div:first-of-type {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }

  & > div:nth-of-type(2) {
    overflow-y: auto;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }

  & > div:last-of-type {
    padding: ${({ theme }) => `0 ${theme.spacings.xl} ${theme.spacings.m}`};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin: ${({ theme }) => `0 ${theme.spacings.m}`};
    width: 100%;

    &[data-variant="small"] {
      border-radius: 0;
      margin: 0;
    }
  }
`;
//# sourceMappingURL=Modal.js.map